var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{class:{
      semibold: _vm.weight === 'semibold',
      light: _vm.weight === 'light',
      'mb-4': _vm.description
    }},[_vm._v("\n    "+_vm._s(_vm.label)+"\n    "),_vm._t("default")],2),(_vm.description)?_c('doe-paragraph',{attrs:{"description":_vm.description}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }